import type { HTMLAttributes, ReactNode } from "react";
import type { ChipTone } from "../lib/types";

type SurfaceProps = HTMLAttributes<HTMLElement> & {
  children: ReactNode;
};

export function Surface({ className = "", children, ...props }: SurfaceProps) {
  return (
    <section className={`ops-surface ${className}`.trim()} {...props}>
      {children}
    </section>
  );
}

export function SurfaceHeader({
  title,
  titleId,
  count,
  detail,
  action,
}: {
  title: string;
  titleId: string;
  count?: number;
  detail?: string;
  action?: ReactNode;
}) {
  return (
    <header className="ops-surface-header">
      <div>
        <h2 id={titleId}>{title}</h2>
        {detail ? <p>{detail}</p> : null}
      </div>
      {typeof count === "number" || action ? (
        <div className="ops-surface-actions">
          {typeof count === "number" ? (
            <span
              className="ops-surface-count"
              aria-label={`${count} ${count === 1 ? "item" : "items"}`}
            >
              {count}
            </span>
          ) : null}
          {action}
        </div>
      ) : null}
    </header>
  );
}

export function StatusBadge({
  tone = "gray",
  children,
}: {
  tone?: ChipTone;
  children: ReactNode;
}) {
  return <span className={`ops-status ops-status--${tone}`}>{children}</span>;
}
